import { mddLogApi, getRequestIp, getRequestIp_https, mddLogApi_https } from '@/request/api'; // 导入我们的api接口
import {isIos, isPC, isMdd} from '@/common/mddH5/1.0.0/tool/assert'
import { mddGetUserInfo } from "@/common/mddH5/1.0.0/mdd/asyncFunc"

// 基础配置对象
const config = {
  platform: 2, // 打点平台类型：0 官网打点、1 OTT大屏H5打点、2 APP小屏h5打点、3 小程序打点
  logTime: 300, // 延迟上传时间
  isHttps: false, // 是否使用https,设置为true主要是为了在测试环境用https
  // 其他可配置参数
};

const getIpFn = ()=>{
	const defaultIp = '127.0.0.1'
  const func = config.isHttps ? getRequestIp_https : getRequestIp
  return func().then(res => {
		console.log('res-getRequestIp', res)
		if(res.msgType===0){
			return res.data&&res.data.requestIp||defaultIp
		}else{
			return defaultIp
		}
	}).catch(err=>{
		return defaultIp
	})
}

const getStateIp = async()=>{
	let local_ip = window.sessionStorage&&window.sessionStorage.getItem('mddIp');
	let visit_ip = '';
	if(local_ip){
		visit_ip = local_ip
	}else{
		let ip = await getIpFn()
		visit_ip = ip
		window.sessionStorage&&window.sessionStorage.setItem('mddIp', visit_ip);
	}
	return visit_ip
}

// 生成打点参数
const createLogParams = async(obj = {}, _userInfo)=> {

  let inituserCache = '';
  inituserCache = window.localStorage&&window.localStorage.getItem('inituser');
  // 未登录的时候使用一个随机字符串用于记录匿名用户，永久存储在localStorage中利于uv数据更加准确
  if (!inituserCache) {
    inituserCache = Math.random().toString(36).substr(2);
    window.localStorage&&window.localStorage.setItem('inituser', inituserCache);
  }

  let _user_id = inituserCache
  if (isMdd) {
    let userInfo = _userInfo || await mddGetUserInfo()
    if (userInfo) {
      _user_id = (userInfo && userInfo.id) || inituserCache
    }
  } else {
    _user_id = (_userInfo && (_userInfo.uuid || _userInfo.id)) || inituserCache
  }

  let device_num = localStorage.getItem('device_num')
  // 记录用户，永久存储在localStorage中利于uv数据更加准确
  if (!device_num) {
    device_num = Math.random().toString(36).substr(2)
    localStorage.setItem('device_num', device_num)
  }

  let visit_ip = await getStateIp()

  let result = {
    page: obj.page || '-1', //页面
    action: obj.action || '-1', // 动作
    channel: obj.channel || '-1', // 自定义的渠道
    game_id: obj.game_id || '-1', // 活动id
    label: obj.label || '-1', // 标签
    value: obj.value || '-1', // 打点值
    category: isMdd ? '1' : '0',
    create_time: Date.parse(new Date()),
    platform: isPC ? 'pc' : (isIos ? 'ios' : 'Android'), //平台
    user_id: _user_id || inituserCache, // 用户uuid
    visit_ip,
    detail: obj.detail || {} ,//额外参数
  };
  result.detail = JSON.stringify({...result.detail, device_num})

  return { data: result };
}



let timer = null
let logArr = []
const toUploadLog = (p) => {
  logArr.push(p)
  if (!timer) {
    let params = {
      platform: config.platform,
      logData: logArr
    }
    timer = setTimeout(() => {
      // console.log('进入了', params)
      clearTimeout(timer)
      timer = null
      logArr = [] // 重新赋值为空数组，但不会影响原数组引用
      const func = config.isHttps ? mddLogApi_https : mddLogApi;
      return func(params)
    }, config.logTime)
  }
}

// 初始化配置
export const initUploadLogs = function (options = {}) {
  Object.assign(config, options);
  console.log('UploadLogs initialized with config:', config);
};

// 埋点-多个埋点，可能有300ms延迟
export const uploadLogs = async function (options, _userInfo, isDelay = true) {
    if (!options.page || !options.action) {
        console.error('打点参数异常')
        return
    }
	let params = await createLogParams(options, _userInfo);
	console.log('logs_params>>',params)

	if (isDelay) {
		return toUploadLog(params)
	} else {
    const func = config.isHttps ? mddLogApi_https : mddLogApi;
		return func({
			platform: config.platform,
			logData: [params]
		})
	}
}

// 导出默认对象
export default {
  init: initUploadLogs,
  upload: uploadLogs
};
